import { createSlice } from '@reduxjs/toolkit';
import {
    fetchClients,
    addWaste,
    showWasteById,
    showWaste,
    editWaste,
    removeWaste,
    generateIncome,
    generateMonthlyIncome
}  from '../actions/waste';

export const wasteSlice = createSlice({
    name: 'waste',
    initialState: {
        loading: false,
        clients: [],
        currentWaste: {},
        meta: {},
        wastes: [],
        error: null
    },
    reducers: {

    },
    extraReducers:(builder) => {
        builder
        // FETCH USER'S CLIENTS
        .addCase(fetchClients.pending,(state) => { state.loading = true })
        .addCase(fetchClients.fulfilled,(state, action) => { 
            state.loading = false;
            state.clients = action.payload
        })
        .addCase(fetchClients.rejected, (state) => { state.loading = false  })
         // ADD WASTE
         .addCase(addWaste.pending,(state) => { state.loading = true })
         .addCase(addWaste.fulfilled,(state, action) => { 
            state.loading = false;
            state.currentWaste = action.payload;
         })
         .addCase(addWaste.rejected, (state) => { state.loading = false  })
        // SHOW WASTE
        .addCase(showWaste.pending,(state) => { state.loading = true })
        .addCase(showWaste.fulfilled,(state, action) => { 
            state.loading = false;
            state.meta = action.payload.meta;
            state.wastes = action.payload.data
        })
        .addCase(showWaste.rejected, (state) => { state.loading = false  })
        // EDIT WASTE 
        .addCase(editWaste.pending,(state) => { state.loading = true })
        .addCase(editWaste.fulfilled,(state, action) => { 
           state.loading = false;
           state.currentWaste = action.payload;
        })
        .addCase(editWaste.rejected, (state) => { state.loading = false  })
        // REMOVE WASTE
        .addCase(removeWaste.pending, (state) => { state.loading = true })
        .addCase(removeWaste.fulfilled, (state, action) => {
            state.loading = false;
            state.wastes = action.payload.data;
        })
        .addCase(removeWaste.rejected, (state) => {
            state.loading = false;
        })
        // SHOW WASTE BY ID
        .addCase(showWasteById.pending,(state) => { state.currentWaste.loading = true })
        .addCase(showWasteById.fulfilled,(state, action) => { 
            state.currentWaste.loading = false;
            state.currentWaste = action.payload;
        })
        .addCase(showWasteById.rejected, (state) => { state.currentWaste.loading = false  })
         // GENERATE INCOME
         .addCase(generateIncome.pending,(state) => { 
            state.currentWaste.loading = true;
            state.error = null;
        })
        .addCase(generateIncome.fulfilled,(state, action) => {
            state.currentWaste.loading = false;
            state.error = null;
        })
        .addCase(generateIncome.rejected, (state, action) => { 
            state.currentWaste.loading = false;
            state.error = action.error.message;

        })
        // GENERATE MONTHLY INCOME
        .addCase(generateMonthlyIncome.pending,(state) => { 
            state.currentWaste.loading = true;
            state.error = null;
        })
        .addCase(generateMonthlyIncome.fulfilled,(state, action) => {
            state.currentWaste.loading = false;
            state.error = null;
        })
        .addCase(generateMonthlyIncome.rejected, (state, action) => { 
            state.currentWaste.loading = false;
            state.error = action.error.message;

        })
    }
});

export default wasteSlice.reducer; 
